
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/[postId]",
      function () {
        return require("private-next-pages/post/[postId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post/[postId]"])
      });
    }
  